import script from "./icon-bulk-camera.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-bulk-camera.vue?vue&type=script&lang=ts&setup=true"

import "./icon-bulk-camera.vue?vue&type=style&index=0&id=105cffbe&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-105cffbe"]])

export default __exports__